import { usePageModels } from '@/context/PageModels';
import { get, map, pipe, replace, trim } from 'lodash/fp';
import React, { useCallback, useEffect } from 'react';
import { facetMatchWith, matchLanguageDictionary } from './facet.resolvers';

export const useGetLanguageLabels = () => {
  const { languages } = usePageModels();
  return languages?.languageLabels || {};
};

export const useProcessFacets = (elasticFacets: any[]) => {
  const [facets, setFacets] = React.useState<any[]>([]);
  const { languages } = usePageModels();

  const languageLocalMatch = useCallback(
    (inputFacets) =>
      map(
        facetMatchWith('language', matchLanguageDictionary(languages?.languageLabels)),
        inputFacets,
      ),
    [languages?.languageLabels],
  );

  const portalLabelRemoval = useCallback(
    (inputFacets) =>
      map((facetItem: any) => ({
        ...facetItem,
        label: pipe(
          get('label'),
          replace(/\(Portal\)|\(PORTAL\)|\(portal\)/g, ''),
          trim,
        )(facetItem),
      }))(inputFacets),
    [],
  );

  useEffect(() => {
    if (elasticFacets.length > 0) {
      const parsedFacets = pipe(languageLocalMatch, portalLabelRemoval)(elasticFacets);
      setFacets(parsedFacets);
    }
  }, [elasticFacets, languages?.languageLabels, languageLocalMatch, portalLabelRemoval]);

  return facets;
};
